import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmLinkType } from '../interfaces/IKnmLinkType';

export async function fetchKnmLinkTypes(): Promise<IKnmLinkType[]> {
  return apiGet<IKnmLinkType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-link-types`);
}
